import fetch from "api/utils/enhancedFetch";
import { getProxycadorHost } from "environment";

export const fetchCountryByIp = (): Promise<string> =>
  fetch(`${getProxycadorHost()}/proxycador/api/getCountry`)
    .then((resp) => resp.text())
    .then((country) => country?.toLowerCase());
